export const ROLES = {
  Basic: "Basic",
  Admin: "Admin",
};
